import { render } from "./AddDescription.vue?vue&type=template&id=6d4a7886&scoped=true&ts=true"
import script from "./AddDescription.vue?vue&type=script&lang=ts"
export * from "./AddDescription.vue?vue&type=script&lang=ts"

import "./AddDescription.vue?vue&type=style&index=0&id=6d4a7886&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d4a7886"]])

export default __exports__